import styled from 'styled-components';
import { baseColors } from '@groupby/ui-components';
export const BannerContainer = styled.div `
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1300;
  background-color: ${baseColors.white};
  border-top: 1px solid ${baseColors.gray200};
  padding: ${({ theme }) => theme.spacing(2)} ${({ theme }) => theme.spacing(3)};
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing(3)};
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
`;
export const BannerContent = styled.div `
  flex: 1;
`;
export const BannerHeading = styled.h3 `
  margin: 0 0 ${({ theme }) => theme.spacing(0.5)} 0;
  font-size: 0.9375rem;
  font-weight: 600;
  color: ${baseColors.background900};
`;
export const BannerBody = styled.p `
  margin: 0;
  font-size: 0.8125rem;
  color: ${baseColors.background600};
  line-height: 1.5;
`;
export const BannerActions = styled.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  flex-shrink: 0;
`;
